/**
 * Format phone number from +15872007123 to +1 587-200-7123
 * @param {string} phone - Phone number to format
 * @returns {string} Formatted phone number
 */
export const formatPhoneNumber = (phone) => {
  if (!phone) return '';
  
  // Remove everything except digits and +
  const cleaned = phone.replace(/[^\d+]/g, '');
  
  // Check for +1 format (12 digits total)
  if (cleaned.startsWith('+1') && cleaned.length === 12) {
    const areaCode = cleaned.slice(2, 5);    // 587
    const prefix = cleaned.slice(5, 8);      // 200
    const lineNumber = cleaned.slice(8, 12); // 7123
    return `+1 ${areaCode}-${prefix}-${lineNumber}`;
  }
  
  // Optional: Handle other formats if needed
  // Example: 15872007123 (without +) → +1 587-200-7123
  if (cleaned.startsWith('1') && cleaned.length === 11) {
    const areaCode = cleaned.slice(1, 4);
    const prefix = cleaned.slice(4, 7);
    const lineNumber = cleaned.slice(7, 11);
    return `+1 ${areaCode}-${prefix}-${lineNumber}`;
  }
  
  // Return original if no match
  return phone;
};